export const getDateRangeFilter = (
  selectedFilter: string
): { startDate: string; endDate: string } => {
  const today = new Date();
  let startDate: string;
  let endDate: string;

  switch (selectedFilter) {
    case "Today":
      startDate = endDate = today.toISOString().split("T")[0];
      break;

    case "Yesterday":
      startDate = endDate = new Date(today.getTime() - 1 * 24 * 60 * 60 * 1000)
        .toISOString()
        .split("T")[0];
      break;

    case "Last 7 days":
      startDate = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000)
        .toISOString()
        .split("T")[0];
      endDate = today.toISOString().split("T")[0];
      break;

    case "Upcoming 7 days":
      startDate = today.toISOString().split("T")[0];
      endDate = new Date(today.getTime() + 7 * 24 * 60 * 60 * 1000)
        .toISOString()
        .split("T")[0];
      break;

    case "Last 1 Month": {
      const lastMonthDate = new Date(today);
      lastMonthDate.setMonth(today.getMonth() - 1);

      startDate = lastMonthDate.toISOString().split("T")[0];
      endDate = today.toISOString().split("T")[0];
      break;
    }
    default:
      startDate = endDate = today.toISOString().split("T")[0]; // Default to today if no match
  }

  return { startDate, endDate };
};

export const formatDate = (dateString: string | undefined): string => {
  return dateString
    ? new Date(dateString).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      }) +
        ", " +
        new Date(dateString).toLocaleDateString("en-GB", { weekday: "long" })
    : "";
};